export default __webpack_public_path__ + "static/media/magnifying_glass_100_100.4c8c1fa4.png";